import service from '@/services/superaccess'

const access_day = {
  state: {
    modal_access_day: false,
    access_day: {},
    clear_form: false,
    edit_access_day: false,
    load_data_access_day: false
  },
  mutations: {
    setAccessDayModal (state, modal_state) {
      state.modal_access_day = modal_state
    },
    setAccessDay (state, access_day) {
      state.access_day = access_day
    },
    setClearForm (state, clear_form) {
      state.clear_form = clear_form
    },
    setEditAccessDay (state, edit_access_day) {
      state.edit_access_day = edit_access_day
    },
    setLoadData (state, status) {
      state.load_data_access_day = status
    }
  },
  getters: {
    getModalAccessDay (state) {
      return state.modal_access_day
    },
    getAccessDay (state) {
      return state.access_day
    },
    getClearForm (state) {
      return state.clear_form
    },
    getEditAccessDay (state) {
      return state.edit_access_day
    },
    getLoadDataAccessDay (state) {
      return state.load_data_access_day
    }
  },
  actions: {
    retrieveDataAccessDay (context, payload) {
      return service.get('/api/access_day/new', context)
    },
    setModalAccessDay (context, payload) {
      context.commit('setAccessDayModal', payload)
    },
    setDataAccessDay (context, payload) {
      context.commit('setAccessDay', payload)
    },
    setStatusClearForm (context, payload) {
      context.commit('setClearForm', payload)
    },
    setStatusEditAccessDay (context, payload) {
      context.commit('setEditAccessDay', payload)
    },
    setStatusLoadDataAccessDay (context, payload) {
      context.commit('setLoadData', payload)
    }
  }
}

export default access_day



// WEBPACK FOOTER //
// app/javascript/src/store/access_day.js